import st from "@/styles/LoginPage.module.scss";
import React from "react";
import CommonClass from "@/utils/common";
import HaveLoggedInterface from "@/types_and_interfaces/have_logged_interface.tsx";
import clsx from "clsx";
import LoginBack from "@/components/LoginBack.tsx";
import MainLoginForm from "@/pages/login/elemsV2/MainLoginForm.tsx";
import {getDeviceUUID} from "@/utils/export_functions.ts";




const StepOneForm:React.FC = ({}) => {
    const pastUser = localStorage.getItem(CommonClass.local_storage_fields.have_logged_data)
    const past_data: HaveLoggedInterface = pastUser !== null ? JSON.parse(pastUser) : {}
    const deviceUid= getDeviceUUID() || ""
    const past_registered = typeof past_data === "object" && Object.keys(past_data).length && typeof deviceUid === "string" && deviceUid.length && past_data.has_pwd


    return (
        <div className={clsx(st.sides, past_registered && st.past_registered)}>

            <div className={clsx(st.left, st.side)}>
                <MainLoginForm />
            </div>

            {past_registered ? (
                <div className={clsx(st.right, st.side)}>
                    <div className={st.inner}>
                        <LoginBack/>
                    </div>
                </div>
            ) : null}

        </div>
    )
}





export default StepOneForm